export default {"src":"/uk/_next/static/media/gift.68b5dda0.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};